import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-popup.component.html',
})
export class ConfirmationPopupComponent {
  @Input() isVisible: boolean = false;
  @Input() message: string = ''; 
  @Input() header: string = ''; 
  @Input() confirmAction?: () => void;
  @Input() cancelAction?: ()=> void;
  @Output() onConfirm: EventEmitter<void> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();

  confirm() {
    if(this.confirmAction){
      this.confirmAction();
    }else{
      this.onConfirm.emit();
    }
  }

  cancel() {
    if(this.cancelAction){
      this.cancelAction()
    }else{
      this.onCancel.emit();
    }
  }
}
